import img_1 from './img/img_1.jpg';
import img_2 from './img/img_2.jpg';
import img_3 from './img/img_3.jpg';

export const slides = [
   img_1,
   img_2,
   img_3
]